import React from 'react';
import imageError from 'assets/img/mobile-error@3x.png';
import {
  Row, Col, Button,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function ErrorComponent( { error, reload = false }: { error: any; reload?: boolean } ) {
  const { t } = useTranslation();
  return (
    <Row className="">
      <Col md className="mt-5 card--light d-flex align-items-center justify-content-center flex-column">

        <img src={imageError} alt="An error ocurred while saving your card, please try again" style={{ height: 150 }} />
        <h1 className="text--green2">{t( 'ups' )}</h1>
        <p>
          {!!error && (
            <>
              {error.toString()}
              <br />
              <br />
            </>
          )}
        </p>
        <br />
        <br />
        {!!reload && reload && (
          <Button
            onClick={() => {
              window.location.reload();
            }}
          >
            {t( 'try' )}
          </Button>
        )}

      </Col>
    </Row>
  );
}

export default ErrorComponent;
